import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P57-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page57/E1/Key/answerKey.png',
    component: D1,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page57/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/3.jpg', input: true, answer: "line" },
        { url: 'img/FriendsPlus/Page57/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/5.jpg', input: true, answer: "white" },
        { url: 'img/FriendsPlus/Page57/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/7.jpg', input: true, answer: "kite" },
        { url: 'img/FriendsPlus/Page57/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page57/E1/9.jpg' },
      ],


    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P57-E2',
    audio: 'img/FriendsPlus/Page57/Audio/audio-e2-p57.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page57/E2/Key/answerKey.png',
    component: D1,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/tieude-e2-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page57/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page57/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/6.jpg', input: true, answer: "kite" },
        { url: 'img/FriendsPlus/Page57/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page57/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/9.jpg', input: true, answer: "white" },
        { url: 'img/FriendsPlus/Page57/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page57/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page57/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/13.jpg', input: true, answer: "line" },
        { url: 'img/FriendsPlus/Page57/E2/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page57/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/16.jpg', input: true, answer: "nine" },
        { url: 'img/FriendsPlus/Page57/E2/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page57/E2/18.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P57-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page57/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read. Circle the words with i_e. Underline the words with i.', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          "Here are",	//0
          "in a line.",	//0

          "There’s a pig on my kite.",	//1
        ],
        answers: { '1-4': 'circle', '2-10': 'circle', '2-4': 'underline' },
        initialValue: {},
      },
      Layout: `
      <div style="line-height: 58px">
          <div>
          <img src="img/FriendsPlus/Page57/E3/1.jpg" />
          </div>
        <span style="margin-right:150px"> 
            <input id='0' type='Circle' />
           <span style="border: 2px solid gray;padding:3px; border-radius: 50%;"> nine </span>  
           <u> figs </u> 
           <input id='1' type='Circle' />
        </span>
        <span><input id='2' type='Circle' /></span>
      </div>
      `,
    },
  },
  4: {
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P57-E4',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page57/E4/Key/answerKey.png',
    checkDuplicated: true,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page57/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/3.jpg', input: true, answer: "figs/pig" },
        { url: 'img/FriendsPlus/Page57/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page57/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/6.jpg', input: true, answer: "line/kite" },
        { url: 'img/FriendsPlus/Page57/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/8.jpg', input: true, answer: "figs/pig" },
        { url: 'img/FriendsPlus/Page57/E4/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page57/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/11.jpg', input: true, answer: "line/kite" },
        { url: 'img/FriendsPlus/Page57/E4/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page57/E4/13.jpg' },
      ],

    ]
  },



}
export default json;